import state from './moduleCashFlowState.js'
import mutations from './moduleCashFlowMutations.js'
import actions from './moduleCashFlowActions.js'
import getters from './moduleCashFlowGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

